import { styled } from '@linaria/react';

export default styled.div`
  font-weight: 400;
  font-size: 16px;
  line-height: 26px;
  margin-bottom: 10px;
`;
